import { useDispatch, useSelector } from 'react-redux'
import { getBranchList } from '../../../actions/commonAction';
import { editCargoTracking } from '../../../actions/batchManagementActions';
import UniDialog from '../../../components/Common/UniDialog';
import { useEffect, useState } from 'react';
import { makeStyles, TextField } from '@material-ui/core';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Alert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import { useTranslation } from 'react-i18next';
import { showAlertSnackbar } from '../../../reducers/uiSlice';

const useStyles = makeStyles((theme) => ({
    itemsStyle: {
        marginTop: 10
    }
})); 

export default function AddTrajectoryComment(props) {
    const {t} = useTranslation('batchManagement');
    const classes = useStyles();
    const dispatch = useDispatch();

    const { openModal, onClose, batchInfo } = props;

    const moment = require('moment');

    const [comment, setComment] = useState('');
    const [time, setTime] = useState('');
    const [warehouse, setWarehouse] = useState('');
    const [boxes, setBoxes] = useState('');
    const [branches, setBranches] = useState([]);

    const handleCommentChange = (event) => {
        setComment(event.target.value);
    }
    const handleTimeChange = (event) => {
        console.log(event.target.value)
        setTime(event.target.value);
    }
    const handleWarehouseSelect = (event) => {
        setWarehouse(event.target.value);
    }
    const handleBoxesChange = (event) => {
        setBoxes(event.target.value)
    }

    useEffect(() => {
        if(openModal) {
            dispatch(getBranchList()).then((branchesCurr)=>{
                setBranches(branchesCurr);
            })
        }        
    }, [openModal])
    useEffect(() => {
        if(batchInfo) {
            setTime(moment.unix(batchInfo.update_time).format("YYYY-MM-DD HH:mm:ss"));
            setWarehouse(batchInfo.warehouse);
            setBoxes(batchInfo.boxes);
            setComment(batchInfo.comments);
        }
    }, [batchInfo])

    return (
        <>
            <UniDialog
                title={t('edit_status')}
                maxWidth='sm'
                open={openModal}
                onClose={handleClose}
                fullWidth={true}
                onFinish={handleSubmit}
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column'
                    }}
                >
                    <div>{t('status_time')}(YYYY-MM-DD HH:mm:ss)</div>
                    <TextField
                        variant="outlined"
                        value={time}
                        fullWidth={true}
                        onChange={handleTimeChange}
                        className={classes.itemsStyle}
                    />
                    <div className={classes.itemsStyle}>{t('warehouse')}</div>
                    <Select
                        variant="outlined"
                        labelId="upload-warehouse-label"
                        id="upload-warehouse-select"
                        defaultValue={warehouse}
                        onChange={handleWarehouseSelect}
                        className={classes.itemsStyle}
                    >
                        {
                            branches.map((branch, index) => {
                                return <MenuItem key={index} value={branch.id}>{branch.name}</MenuItem>
                            })
                        }
                    </Select>
                    <div className={classes.itemsStyle}>{t('box_number')}</div>
                    <TextField
                        variant="outlined"
                        value={boxes}
                        fullWidth={true}
                        onChange={handleBoxesChange}
                        className={classes.itemsStyle}
                    />
                    <div className={classes.itemsStyle}>{t('remark')}</div>
                    <TextField 
                        multiline 
                        variant="outlined"
                        rows={3}
                        value={comment}
                        fullWidth={true}
                        onChange={handleCommentChange}
                        className={classes.itemsStyle}
                    />
                </div>
            </UniDialog>
        </>
        
    );

    function handleClose() {    
        onClose();
    };

    function handleSubmit() {
        const param = {
            boxes: boxes,
            comments: comment,
            id: batchInfo.id,
            update_time: moment(time)/1000,
            warehouse: warehouse 
        }
        dispatch(editCargoTracking(param))
        .then(() => {
            dispatch(showAlertSnackbar({message: t('edit_success_message'), type: 'success'}))
        })
        .catch(() => {
            dispatch(showAlertSnackbar({message: t('edit_fail_message'), type: 'error'}))
        })
    }
}